<div class="d-flex flex-row align-items-center">
  <div class="indice-cor me-2" [ngStyle]="{ 'background': cor }">
  <p>{{ indice }}º</p>
  </div>

  <div class="d-flex flex-column w-100">
    <div>
      <p class="tit-principal">{{ dados.nome }}</p>
    </div>
    <div class="d-flex justify-content-between">
      <p class="tit-principal"><span class="tit-segundario">Distância:</span> {{dados.distanciaTotal}} km</p>
      <p class="tit-principal"><span class="tit-segundario">Peso:</span> {{dados.pesoTotal}} kg</p>
      <p class="tit-principal"><span class="tit-segundario">Vol.:</span> {{dados.volTotal}}</p>
      <p class="tit-principal tit-eye btn-hover d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#popUp-dist-percorrida" (click)="mudarCor()" > <img src="assets/img/icons/icon_eye_green.svg" alt="" class="me-1"> Detalhar</p>
    </div>
  </div>
</div>
